/**
 * @copyright   2010-2015, The Titon Project
 * @license     http://opensource.org/licenses/BSD-3-Clause
 * @link        http://titon.io
 */

define([
    './input-wrapper',
    './input-checkbox',
    './input-radio',
    './input-select'
], function(Input) {

return Input;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/titon-toolkit/js/components/input.js
// module id = 437
// module chunks = 1